<div class="table-row">
    <div class="table-row__column">
        <ng-content select="[left]" />
    </div>

    <div class="table-row__column">
        <ng-content select="[right]" />
    </div>
</div>
